import React from "react";

import styles from "./index.module.scss";

interface Props {
  smallCard?: boolean;
}

const EventGrid: React.FC<Props> = (props) => {
  const { children, smallCard = false } = props;

  const cards = React.Children.map(children, (card, i) => {
    return (
      <div className={smallCard ? styles.smallCard : styles.card} key={i}>
        {card}
      </div>
    );
  });

  return <div className={styles.container}>{cards}</div>;
};

export { EventGrid };
